<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect></BaseFacilitySelect>
    </div>
    <div>
      <div class="card">
        <div class="card-header">
          <strong>RespSafe report module</strong>
        </div>
        <div class="card-body">
          <div>
            <p>
              Follow the module below to enter numbers for your annual RespSafe report. Before starting the report,
              you may find it helpful to download a current version of the Combined Immunization Output from the Check immunization status screen.
              Once ready, launch this year’s RespSafe report module below.
            </p>
            <p>
              Reports must be submitted by <b>May 15th</b> to be considered for this year’s RespSafe awards.
            </p>
          </div>
          <div>
            <b-button class="d-block p-2 bg-mdh text-white" @click="checkRegistration">
              Launch report module
            </b-button>
          </div>
        </div>
        <div>
          <div>
            <b-modal id="missing-registration-modal" hide-header hide-footer>
              <h2>RespSafe facility missing enrollment warning</h2>
              <hr/>
              <p>This facility was not registered to participate in RespSafe.<br></p>
              <p>Questions about the RespSafe program should be sent to <a href="mailto:Health.RespSafe@state.mn.us"><u>Health.RespSafe@state.mn.us</u></a>.</p>
              <p>Questions about the VaxCheck application should be sent to the VaxCheck team at <a href="mailto:Health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>.</p>
              <div>
                <b-button @click="closeMissingModal" style="margin-right:15px;">Back to enrollment page</b-button>
              </div>
            </b-modal>
          </div>
          <div>
            <b-modal id="duplicate-report-modal" hide-header hide-footer>
              <h2>RespSafe facility duplicate report warning</h2>
              <hr/>
              <p>This facility submitted an annual RespSafe report on {{ this.reportSubmissionDate }}.<br></p>
              <p>Questions about the RespSafe program should be sent to <a href="mailto:Health.RespSafe@state.mn.us"><u>Health.RespSafe@state.mn.us</u></a>.</p>
              <p>Questions about the VaxCheck application should be sent to the VaxCheck team at <a href="mailto:Health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>.</p>
              <div>
                <b-button @click="closeDuplicateModal" style="margin-right:15px;">Back to enrollment page</b-button>
              </div>
            </b-modal>
          </div>
          <div>
            <b-modal id="no-submissions-modal" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
              <h2>RespSafe not currently accepting report submissions</h2>
              <hr/>
              <p>RespSafe reports may be submitted between January 1st and May 15th of each year.<br></p>
              <p>Questions about the RespSafe program should be sent to <a href="mailto:Health.RespSafe@state.mn.us"><u>Health.RespSafe@state.mn.us</u></a>.</p>
              <p>Questions about the VaxCheck application should be sent to the VaxCheck team at <a href="mailto:Health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>.</p>
              <div>
                <b-button @click="pushHomePage" style="margin-right:15px;">Back to home</b-button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>

import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";
import axios from "axios";
import router from "@/router";

export default {
  name: 'respSafeSubmissionConfirmation',
  components: {BaseFacilitySelect},
  data: () => ({
    reportSubmissionDate: new Date(),
    dueDate: new Date(0,4,15),
    currentDate: new Date(),
    respiratorySeason: ''
  }),

  mounted() {
    this.checkReportPeriod()
    this.handleRespiratorySeason()
  },

  methods: {
    pushReportModulePage() {
      router.push("respSafeReportModule")
    },
    pushHomePage() {
      router.push('home')
    },
    pushMissingModal() {
      this.$bvModal.show('missing-registration-modal')
    },
    closeMissingModal() {
      this.$bvModal.hide('missing-registration-modal')
    },
    pushDuplicateModal() {
      this.$bvModal.show('duplicate-report-modal')
    },
    closeDuplicateModal() {
      this.$bvModal.hide('duplicate-report-modal')
    },
    pushNoSubmissionsModal() {
      this.$bvModal.show('no-submissions-modal')
    },

    checkReportPeriod() {
      if (this.currentDate.getMonth() >= this.dueDate.getMonth() && this.currentDate.getDate() > this.dueDate.getDate()) {
        this.pushNoSubmissionsModal()
      }
    },

    handleRespiratorySeason() {
      let startingYear = ''
      let endingYear = ''

      let currUTCYear = new Date(new Date().toUTCString()).toISOString().split('-')[0]
      let currUTCMonth = new Date(new Date().toUTCString()).toISOString().split('-')[1]

      if (currUTCMonth >= 7) {
        startingYear = currUTCYear
        endingYear = parseInt(currUTCYear) + 1
      } else {
        startingYear = parseInt(currUTCYear) - 1
        endingYear = currUTCYear
      }

      this.startingYear = startingYear.toString()
      this.endingYear = endingYear.toString()
      this.respiratorySeason = startingYear.toString() + '-' + endingYear.toString()
    },

    checkRegistration() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/org`).then(response => {
        this.org = response.data
        if(this.org !== null && this.$store.state.selectedFacility) {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/respsafe/registration/${this.$store.state.selectedFacility.id}`)
            .then(response => {
              if (response.data[0] === undefined || response.data[0]?.respiratorySeason !== this.respiratorySeason) { // no registrations found
                this.pushMissingModal()
              } else {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/respsafe/report/${this.$store.state.selectedFacility.id}`)
                  .then(response => {
                    if (response.data[0]?.reportId !== null && response.data[0]?.registration.respiratorySeason === this.respiratorySeason) {
                      this.reportSubmissionDate = this.formatDate(response.data[0]?.reportDate)
                      this.pushDuplicateModal()
                    } else {
                      this.pushReportModulePage()
                    }
                  })
              }
            })
        } else {
          this.showRootToast('Error','Please select a facility.','danger')
        }
      })
    },

    formatDate(datetimeString) {
      const date = new Date(datetimeString)
      const options = {year: 'numeric', month: 'long', day: 'numeric'}

      return date.toLocaleDateString('en-US', options)
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },
  }
}
</script>
